import { render } from "./MailsTable.vue?vue&type=template&id=deccf694&scoped=true"
import script from "./MailsTable.vue?vue&type=script&lang=js"
export * from "./MailsTable.vue?vue&type=script&lang=js"

import "./MailsTable.vue?vue&type=style&index=0&id=deccf694&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deccf694"]])

export default __exports__